var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('object',{attrs:{"data":("https://lipis.github.io/flag-icon-css/flags/4x3/" + _vm.code + ".svg"),"type":"image/svg+xml"}})}
var staticRenderFns = []

export { render, staticRenderFns }